import { C as CosmosAssetItemBase$1, d as defineCustomElement$1 } from './p-DwCpGW_o.js';

const CosmosAssetItemBase = CosmosAssetItemBase$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosAssetItemBase, defineCustomElement };
